import ErrorService from "vamos/cockpit/base/services/type/ErrorService";
import Component from "vamos/cockpit/Component";
import Config from "vamos/cockpit/config/Config";
import AppResponse from "vamos/cockpit/model/api/AppResponse";

export default class ApiService {

  private static _instance: ApiService;

  private component: Component;
  private config: Config = new Config();

  public static getInstance() {
    if (!ApiService._instance) {
      ApiService._instance = new ApiService();
    }
    return ApiService._instance;
  }

  public init(component: Component) {
    this.component = component;
  }


  public async getRestJsonData<T>(p_restEndpoint: string, p_isPublic: boolean = false): Promise<T> {
    try {
      const response = await fetch(this.config.getRestUrl(p_restEndpoint, p_isPublic), {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      });
      const content = await response.json() as T;
      await this.checkResponseStatus(response.status, content);
      return content;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public async postRestJsonDataWithoutMessage<T>(p_restEndpoint: string, p_jsonData: any, p_isPublic: boolean = false): Promise<AppResponse<T>> {
    try {
      const response = await fetch(this.config.getRestUrl(p_restEndpoint, p_isPublic), {
        method: "POST",
        body: JSON.stringify(p_jsonData),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      });
      const content = await response.json() as T;
      return { data: content, statusCode: response.status, success: this.isSuccess(response.status) };
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public async getRestJsonDataWithoutMessage<T>(p_restEndpoint: string, p_isPublic: boolean = false): Promise<AppResponse<T>> {
    try {
      const response = await fetch(this.config.getRestUrl(p_restEndpoint, p_isPublic), {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      });
      const content = await response.json() as T;
      return { data: content, statusCode: response.status, success: this.isSuccess(response.status) };
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public async postRestJsonData<T>(p_restEndpoint: string, p_jsonData: any, p_isPublic: boolean = false): Promise<AppResponse<T>> {
    try {
      const responseData = await this.postRestJsonDataWithoutMessage<T>(p_restEndpoint, p_jsonData, p_isPublic);
      await this.checkResponseStatus(responseData.statusCode, responseData.data);
      return responseData;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public async putRestJsonDataWithoutMessage<T>(p_restEndpoint: string, p_jsonData: any, p_isPublic: boolean = false): Promise<AppResponse<T>> {
    try {
      const response = await fetch(this.config.getRestUrl(p_restEndpoint, p_isPublic), {
        method: "PUT",
        body: JSON.stringify(p_jsonData),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      });
      const content = await response.json() as T;
      return { data: content, statusCode: response.status, success: this.isSuccess(response.status) };
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public async putRestJsonData<T>(p_restEndpoint: string, p_jsonData: any, p_isPublic: boolean = false): Promise<AppResponse<T>> {
    try {
      const responseData = await this.putRestJsonDataWithoutMessage<T>(p_restEndpoint, p_jsonData, p_isPublic);
      await this.checkResponseStatus(responseData.statusCode, responseData.data);
      return responseData;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public async postMultiPartFormData(p_restEndpoint: string, p_formData: any, p_isPublic: boolean = false): Promise<any> {
    try {
      const response = await fetch(this.config.getRestUrl(p_restEndpoint, p_isPublic), {
        method: "POST",
        body: p_formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept": "application/json",
        },
      });
      const content = await response.json();
      await this.checkResponseStatus(response.status, content);
      return content;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public async postJsonWithoutChecks(endPoint: string, payload: any): Promise<AppResponse<Response>> {
    const response = await fetch(this.config.getRestUrl(endPoint, false), {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    });

    return { data: response, statusCode: response.status, success: this.isSuccess(response.status) };
  }


  public async delete(endPoint: string): Promise<void> {
    const response = await fetch(this.config.getRestUrl(endPoint, false), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const content = await response.json();
    await this.checkResponseStatus(response.status, content);
  }

  private async checkResponseStatus(statusCode: number, content: any): Promise<void> {
    if (statusCode >= 300) {
      await ErrorService.getInstance().showResponseErrors(content);
      throw new Error(content);
    }
  }

  private isSuccess(statusCode: number): boolean {
    return statusCode >= 200 && statusCode < 300;
  }
}
